package floris.graphics.models.dto.requests.project

import floris.graphics.models.domain.models.interfaces.DateAble
import floris.graphics.models.dto.requests.MediaFileDto
import floris.graphics.models.dto.requests.category.CategoryDto
import floris.graphics.models.dto.requests.techstack.TechstackDto
import floris.graphics.models.dto.requests.user.UserDto
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ProjectDto(
    val id: String = "",
    val user: UserDto = UserDto(),
    val title: String = "",
    val subtitle: String = "",
    val content: String = "",
    @SerialName("preview_video_media_file")
    val previewVideoMediaFile: MediaFileDto? = null,
    @SerialName("thumbnail_media_file")
    val thumbnailMediaFile: MediaFileDto? = null,
    val categories: List<CategoryDto>? = null,
    val techstacks: List<TechstackDto>? = null,
    @SerialName("created_at")
    override val createdAt: String = "",
    @SerialName("updated_at")
    override val updatedAt: String = "",
    @SerialName("deleted_at")
    val deletedAt: String? = null
) : DateAble
